import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { SortComponent } from './SortComponent';
import { useTranslation } from '@shared/core';
import type { SortOption } from '@shared/constants/accommodations';

type Props = Readonly<{
  sortOption: SortOption;
  onSortChange: (sort: SortOption) => void;
  includeCouplesPicks: boolean;
  includeFundSavings?: boolean;
  accentColor?: string;
}>;

const DeskTopListingsHeader: React.FC<Props> = ({ sortOption, onSortChange, includeCouplesPicks, includeFundSavings, accentColor }) => {
  const { t } = useTranslation('accommodationsConsole');
  const listingTrans = t('listingsPanel');

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
    >
      <TextV2 typographyVariant="hed4">{listingTrans.title()}</TextV2>
      <SortComponent
        selectedValue={sortOption}
        onChange={onSortChange}
        includeCouplesPicks={includeCouplesPicks}
        includeFundSavings={includeFundSavings}
        accentColor={accentColor}
      />
    </Flex>
  );
};

export default DeskTopListingsHeader;
